import Button from '@mui/material/Button'
import CentredBanner from '../CentredBanner'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { observer } from "mobx-react-lite"
import { useOrgGuardStore } from '../../../OrgGuardStore';
import { pluralise } from '@gap/utils/language-utils'
import { notNull } from '@gap/utils/utils';
import useStore from 'reusable/mobx-store-utils';
import Typography from '@mui/material/Typography';
import { useOrgSubscriptionTierStore } from '../../org-subscription-tiers/OrgSubscriptionTierStore';

export default observer(function BannerTrialPeriod() {
   const orgGuardStore = useOrgGuardStore()
   const orgSubscriptionTierStore = useOrgSubscriptionTierStore()
   const bannerTrialPeriodStore = useStore((sp) => ({
      get endDate() {
         return notNull(sp.orgGuardStore.trialEndDate)
      },
      get daysUntilTrialEnd() {
         return orgSubscriptionTierStore.daysUntilDate(bannerTrialPeriodStore.endDate)
      },
      get isEndDateAfterToday() {
         return bannerTrialPeriodStore.daysUntilTrialEnd > 0
      }
   }), { orgGuardStore })

   return <CentredBanner callToAction={
      <Button
         size="small"
         variant="contained"
         endIcon={<AutoAwesomeOutlinedIcon />}
         onClick={orgSubscriptionTierStore.upgradePlanModal.open}
      >Choose a plan</Button>
   }>
      {bannerTrialPeriodStore.isEndDateAfterToday
         ? <Typography>You have {bannerTrialPeriodStore.daysUntilTrialEnd} {pluralise(bannerTrialPeriodStore.daysUntilTrialEnd, 'day', 'days')} remaining on your trial</Typography>
         : <Typography>Your trial has expired, please choose a plan to continue</Typography>}
   </CentredBanner>
})
